import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Second Line Approval\n          ")
], -1);
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm" }, "*Any comments provided by the Hiring Manager in relation to the approval will show in the box above.", -1);
const _hoisted_7 = { class: "px-4 py-3 bg-gray-50 text-right sm:px-6" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("button", {
    type: "submit",
    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400"
}, "\n          Next\n        ", -1);
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { ref } from 'vue';
import { Radio } from '@/form';
export default /*#__PURE__*/ _defineComponent({
    __name: 'secondLineApproval',
    setup(__props) {
        const sla_approval = Radio('Are you happy to approve this Offer? *', 'sla_approval');
        const formData = ref({
            textarea: '',
            input: '',
            radio: '',
        });
        const rules = ref({
            textarea: { required },
            input: { required },
            radio: { required },
        });
        const errors = ref({
            textarea: '',
            radio: '',
            input: '',
        });
        const v$ = useVuelidate(rules.value, formData.value);
        const submitForm = () => {
            // Get input elements
            const roleInput = document.getElementById('role');
            const amountInput = document.getElementById('amount');
            const typeInput = document.getElementById('type');
            // Set formData with input values from fields
            if (roleInput)
                formData.value.role = roleInput.value;
            if (amountInput)
                formData.value.amount = amountInput.value;
            if (typeInput)
                formData.value.type = typeInput.value;
            Object.keys(rules.value).forEach((field) => {
                // Set each value as dirty in validation object
                v$.value[field].$touch();
                // Set error in the errors object if field is invalid
                if (v$.value[field].$error)
                    errors.value[field] = v$.value[field].$errors[0].$message;
            });
            const formIsValid = !v$.$invalid;
            if (formIsValid) {
                // save to vuex store and call endpoint here
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode(),
                        _createElementVNode("div", { innerHTML: _unref(sla_approval) }, null, 8, _hoisted_5),
                        _createTextVNode(),
                        _hoisted_6
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                            class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                            onClick: _withModifiers(submitForm, ["prevent"])
                        }, "\n          Reset Form\n        "),
                        _createTextVNode(),
                        _hoisted_8
                    ])
                ])
            ]));
        };
    }
});
